<div class="tab-pane" role="tabpanel" id="declaracion">
    <fieldset id="agregar_declaracion" class="">
        <div class="step_section">
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                    <form [formGroup]="form">
                        <div class="form-horizontal">
                            <div class="form-group" style="padding-bottom: 10px;">
                                <label for="plano" class="col-md-5">Adjunta Plano Topografico (*) Art. 1.4.8.OGUC:</label>
                                <div class="col-md-1" class="inline">
                                    <div class="col-sm-4">
                                        <mat-radio-group formControlName="plano" (change)="add_declaracion()">
                                            <mat-radio-button style="padding-right: 20px" name="plano" value="SI">SI</mat-radio-button>
                                            <mat-radio-button style="padding-right: 20px" name="plano" value="NO">NO</mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group" style="padding-left: 0px">
                                <label for="denominado" class="col-md-2">Denominado</label>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Denominado" id="denominado" name="denominado" formControlName="denominado" (change)="add_declaracion()">
                                    </mat-form-field>
                                </div>
                                <div class="col-md-1"></div>
                                <label for="elaborado" class="col-md-2">Elaborado</label>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Elaborado" id="elaborado" name="elaborado" formControlName="elaborado" (change)="add_declaracion()">
                                    </mat-form-field>
                                </div>
                                <div class="col-md-12">
                                    <label class="l1" for="profesion" class="col-md-2" style="padding-left: 0px;">De Profesion</label>
                                    <div class="col-md-2" style="padding-left: 5px; padding-right: 20px;">
                                        <mat-form-field class="example-full-width" style="width: 145px;">
                                            <input matInput placeholder="De profesion" id="profesion" name="profesion" formControlName="profesion" (change)="add_declaracion()">
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-8"></div>
                                </div>
                            </div>

                        </div>
                    </form>
                </div>
            </div>
        </div>
    </fieldset>
</div>
<div class="separator"></div>